function CardBlue(){
  return(<div>CardBlue</div>)
}

export default CardBlue